import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './components/shared/layout/main/main-layout.component';
import { CustomPreLoadingStrategy } from './services/custom-preloading-strategy';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
        data: { title: 'Home' }
      },
      {
        path: 'users',
        loadChildren: () => import('./components/users/users.module').then(m => m.UsersModule),
        data: { title: 'Users' }
      },
      {
        path: 'functions',
        loadChildren: () => import('./components/functions/functions.module').then(m => m.FunctionsModule),
        data: { title: 'Functions' }
      },
      {
        path: 'roles',
        loadChildren: () => import('./components/roles/roles.module').then(m => m.RolesModule),
        data: { title: 'Roles' }
      },
      {
        path: 'nhanvien',
        loadChildren: () => import('./components/nhanvien/nhanvien.module').then(m => m.NhanVienModule),
        data: { title: 'Nhân viên' }
      },
      {
        path: 'hopdonglaodong',
        loadChildren: () => import('./components/hopdonglaodong/hopdonglaodong.module').then(m => m.HopDongLaoDongModule),
        data: { title: 'Hợp đồng lao động' }
      },
      {
        path: 'loaiphucap',
        loadChildren: () => import('./components/dmloaiphucap/dmloaiphucap.module').then(m => m.DmLoaiPhuCapModule),
        data: { title: 'Loại phụ cấp' }
      },
      {
        path: 'phucap',
        loadChildren: () => import('./components/dmphucap/dmphucap.module').then(m => m.DmPhuCapModule),
        data: { title: 'Phụ cấp' }
      },
      {
        path: 'quanhe',
        loadChildren: () => import('./components/dmquanhe/dmquanhe.module').then(m => m.DmQuanHeModule),
        data: { title: 'Danh mục quan hệ' }
      },
      {
        path: 'thamsokyhieucong',
        loadChildren: () => import('./components/thamsokyhieucong/thamsokyhieucong.module').then(m => m.ThamSoKyHieuCongModule),
        data: { title: 'Tham số ký hiệu công' }
      },
      {
        path: 'nhomkyhieucong',
        loadChildren: () => import('./components/nhomkyhieucong/nhomkyhieucong.module').then(m => m.NhomKyHieuCongModule),
        data: { title: 'Nhóm ký hiệu công' }
      },
      {
        path: 'configluong',
        loadChildren: () => import('./components/configluong/configluong.module').then(m => m.ConfigLuongModule),
        data: { title: 'Cấu hình tham số lương' }
      },
      {
        path: 'phieuluong',
        loadChildren: () => import('./components/dmluong/dmluong.module').then(m => m.DmLuongModule),
        data: { title: 'Danh mục lương' }
      },
      {
        path: 'luongcapbac',
        loadChildren: () => import('./components/dmluongcapbac/dmluongcapbac.module').then(m => m.DmLuongCapBacModule),
        data: { title: 'Danh mục lương cấp bậc' }
      },
      {
        path: 'luongnangsuat',
        loadChildren: () => import('./components/dmluongnangsuat/dmluongnangsuat.module').then(m => m.DmLuongNangSuatModule),
        data: { title: 'Danh mục lương năng suất' }
      },
      {
        path: 'donvi',
        loadChildren: () => import('./components/dmdonvi/dmdonvi.module').then(m => m.DmdonviModule),
        data: { title: 'Danh mục đơn vị' }
      },
      {
        path: 'templateluong',
        loadChildren: () => import('./components/templateluong/templateluong.module').then(m => m.TemplateLuongModule),
        data: { title: 'Danh mục mẫu phiếu lương' }
      },
      {
        path: 'nangdinh',
        loadChildren: () => import('./components/nangdinh/nangdinh.module').then(m => m.NangDinhModule),
        data: { title: 'Danh mục năng định' }
      },
      {
        path: 'daotaohuanluyen',
        loadChildren: () => import('./components/daotaohuanluyen/daotaohuanluyen.module').then(m => m.DaoTaoHuanLuyenModule),
        data: { title: 'Danh mục đào tạo huấn luyện' }
      },
      {
        path: 'khenthuong',
        loadChildren: () => import('./components/khenthuong/khenthuong.module').then(m => m.KhenThuongModule),
        data: { title: 'Danh mục khen thưởng' }
      },
      {
        path: 'ktdang',
        loadChildren: () => import('./components/khenthuongdang/khenthuongdang.module').then(m => m.KhenThuongDangModule),
        data: { title: 'Danh mục khen thưởng Đảng' }
      },
      {
        path: 'ktcongdoan',
        loadChildren: () => import('./components/khenthuongcongdoan/khenthuongcongdoan.module').then(m => m.KhenThuongCongDoanModule),
        data: { title: 'Danh mục khen thưởng Công đoàn' }
      },
      {
        path: 'ktdoanthanhnien',
        loadChildren: () => import('./components/khenthuongdoanthanhnien/khenthuongdoanthanhnien.module').then(m => m.KhenthuongdoanthanhnienModule),
        data: { title: 'Danh mục khen thưởng Đoàn thanh niên' }
      },
      {
        path: 'kldang',
        loadChildren: () => import('./components/kyluatdang/kyluat-dang.module').then(m => m.KyluatDangModule),
        data: { title: 'Danh mục kỷ luật Đảng' }
      },
      {
        path: 'klcongdoan',
        loadChildren: () => import('./components/kyluatcongdoan/kyluat-congdoan.module').then(m => m.KyluatCongdoanModule),
        data: { title: 'Danh mục kỷ luật Công đoàn' }
      },
      {
        path: 'kldoanthanhnien',
        loadChildren: () => import('./components/kyluatdoanthanhnien/kyluat-doanthanhnien.module').then(m => m.KyluatDoanthanhnienModule),
        data: { title: 'Danh mục kỷ luật Đoàn thanh niên' }
      },
      {
        path: 'kyluat',
        loadChildren: () => import('./components/kyluat/kyluat.module').then(m => m.KyLuatModule),
        data: { title: 'Danh mục kỷ luật' }
      },
      {
        path: 'quanlycong',
        loadChildren: () => import('./components/quanlycong/quanlycong.module').then(m => m.QuanLyCongModule),
        data: { title: 'Quản lý công' }
      },
      {
        path: 'quanlyanca',
        loadChildren: () => import('./components/quanlyanca/quanlyanca.module').then(m => m.QuanLyAnCaModule),
        data: { title: 'Quản lý ăn ca' }
      },
      {
        path: 'quanlythunhap',
        loadChildren: () => import('./components/quanlythunhap/quanlythunhap.module').then(m => m.QuanLyThuNhapModule),
        data: { title: 'Quản lý thu nhập' }
      },
      {
        path: 'nhanxethangnam',
        loadChildren: () => import('./components/nhanxethangnam/nhanxethangnam.module').then(m => m.NhanXetHangNamModule),
        data: { title: 'Danh sách nhận xét hàng năm' }
      },
      {
        path: 'nxdang',
        loadChildren: () => import('./components/nhanxethangnamdang/nhanxethangnamdang.module').then(m => m.NhanXetHangNamDangModule),
        data: { title: 'Danh sách nhận xét hàng năm Đảng' }
      },
      {
        path: 'nxcongdoan',
        loadChildren: () => import('./components/nhanxethangnamcongdoan/nhanxethangnamcongdoan.module').then(m => m.NhanXetHangNamCongDoanModule),
        data: { title: 'Danh sách nhận xét hàng năm Công đoàn' }
      },
      {
        path: 'nxdoanthanhnien',
        loadChildren: () => import('./components/nhanxethangnamdoanthanhnien/nhanxethangnamdoanthanhnien.module').then(m => m.NhanXetHangNamDoanThanhNienModule),
        data: { title: 'Danh sách nhận xét hàng năm Đoàn thanh niên' }
      },
      {
        path: 'changePassword',
        loadChildren: () => import('./components/utils/changepassword/changepassword.module').then(m => m.ChangePasswordModule),
        data: { title: 'Thay đổi mật khẩu' }
      },
      {
        path: 'baohiem',
        loadChildren: () => import('./components/baohiem/baohiem.module').then(m => m.BaoHiemModule),
        data: { title: 'Quản lý bảo hiểm' }
      },
      {
        path: 'thuetncn',
        loadChildren: () => import('./components/thuetncn/thuetncn.module').then(m => m.ThueTNCNModule),
        data: { title: 'Quản lý thuế TNCN' }
      },
      {
        path: 'qtctdang',
        loadChildren: () => import('./components/dmqtctdang/dmqtctdang.module').then(m => m.DmqtctdangModule),
        data: { title: 'Danh mục qtct Đảng' }
      },
      {
        path: 'qtctcongdoan',
        loadChildren: () => import('./components/dmqtctcongdoan/dmqtctcongdoan.module').then(m => m.DmqtctcongdoanModule),
        data: { title: 'Danh mục qtct Công đoàn' }
      },
      {
        path: 'configluonggio',
        loadChildren: () => import('./components/dmconfigluonggio/dmconfigluonggio.module').then(m => m.DmConfigLuongGioModule),
        data: { title: 'Danh mục cấu hình lương giờ' }
      },
      {
        path: 'calamviec',
        loadChildren: () => import('./components/calamviec/calamviec.module').then(m => m.CaLamViecModule),
        data: { title: 'Quản lý ca làm việc' }
      },
      {
        path: 'qtctdoanthanhnien',
        loadChildren: () => import('./components/dmqtctdoanthanhnien/dmqtctdoanthanhnien.module').then(m => m.DmqtctdoanthanhnienModule),
        data: { title: 'Danh mục qtct Đoàn thanh niên' }
      },
      {
        path: 'logs',
        loadChildren: () => import('./components/logs/logs.module').then(m => m.LogsModule),
        data: { title: 'Quản lý logs' }
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'error',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./components/shared/error/error.module').then(m => m.ErrorModule),
        data: { title: 'Page Not Found' }
      }
    ]
  },
  {
    path: '**',
    loadChildren: () => import('./components/shared/error/error.module').then(m => m.ErrorModule),
    data: { title: 'Page Not Found' }
  }
];

export const appRouting = RouterModule.forRoot(routes, { preloadingStrategy: CustomPreLoadingStrategy });

@NgModule({
  imports: [
    appRouting,

  ],
  exports: [RouterModule],
  providers: [
    CustomPreLoadingStrategy
  ]
})
export class AppRoutingModule { }
